import {
  z5 as interfaceMeta,
  ga as VOID,
  o6 as setMetadataFor,
  h2 as emptyList,
  t9 as THROW_ISE,
  a1 as Unit_getInstance,
  g9 as Enum,
  p5 as classMeta,
  b3 as listOf,
  e1 as ArrayList,
  s9 as THROW_CCE,
  p1 as MutableList,
  e6 as isInterface,
  a2 as collectionSizeOrDefault,
  r6 as toString,
  k9 as IllegalStateException,
  y9 as ensureNotNull,
  u1 as addAll,
  s2 as joinToString,
  y5 as hashCode,
  s5 as equals,
  c3 as listOf_0,
  m6 as objectMeta,
  n4 as compareValues,
  j1 as LinkedHashMap,
  q1 as MutableMap,
  j8 as substringBefore,
  g8 as substringAfter,
  i7 as contains,
  a4 as sortedWith,
  z9 as lazy,
  g1 as HashMap,
  g4 as toMutableList,
  j4 as toSet,
  h8 as substringBeforeLast,
  e8 as substringAfterLast,
  z8 as trimIndent,
  x5 as getStringHashCode,
  n6 as protoOf,
  q9 as Pair,
  aa as noWhenBranchMatchedException,
  v1 as addAll_0,
  s3 as plus,
  d3 as mapCapacity,
  u6 as coerceAtLeast,
  p3 as plus_0,
  k1 as LinkedHashSet,
  v5 as getObjectHashCode,
  c7 as KProperty1,
  w5 as getPropertyCallableRef,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class TypeModel {}
class TypeNamespace {}
class TypeInstance {}
class TypeDefinition {}
function signature(context, currentDepth, $super) {
  currentDepth = currentDepth === VOID ? 0 : currentDepth;
  return this.jm(context, currentDepth);
}
function instance(arguments_0, nullable, $super) {
  arguments_0 = arguments_0 === VOID ? emptyList() : arguments_0;
  nullable = nullable === VOID ? false : nullable;
  return this.km(arguments_0, nullable);
}
class PrimitiveType {}
class EnumType {}
class StructuredType {}
function appendProperty(name, type, characteristics, index, $super) {
  index = index === VOID ? -1 : index;
  return this.om(name, type, characteristics, index);
}
class TupleType {}
class DataType {}
class PropertyDeclaration {}
class PropertyCharacteristic extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
  static get REFERENCE() {
    return PropertyCharacteristic_REFERENCE_getInstance();
  }
  static get COMPOSITE() {
    return PropertyCharacteristic_COMPOSITE_getInstance();
  }
  static get IDENTITY() {
    return PropertyCharacteristic_IDENTITY_getInstance();
  }
  static get CONSTRUCTOR() {
    return PropertyCharacteristic_CONSTRUCTOR_getInstance();
  }
  static get MEMBER() {
    return PropertyCharacteristic_MEMBER_getInstance();
  }
}
class UnnamedSuperTypeType {}
class CollectionType {}
class TypeModelBuilder {
  constructor(name, resolveImports, namespaces) {
    this.name = name;
    this.jn_1 = resolveImports;
    this.namespaces = namespaces;
    this._model = new TypeModelSimple(this.name);
  }
  be() {
    return this.name;
  }
  kn() {
    return this.namespaces;
  }
  ln() {
    return this._model;
  }
  mn(qualifiedName, imports, init) {
    var b = new TypeNamespaceBuilder(qualifiedName, imports);
    init(b);
    var ns = b.build();
    this._model.addNamespace(ns);
    return ns;
  }
  namespace(qualifiedName, imports, init, $super) {
    imports = imports === VOID ? listOf(SimpleTypeModelStdLib_getInstance().sn_1) : imports;
    return this.mn(qualifiedName, imports, init);
  }
  build() {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.namespaces;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.typemodel.api.TypeModelBuilder.build.<anonymous>' call
      this._model.addNamespace(element);
    }
    if (this.jn_1) {
      this._model.resolveImports();
    }
    return this._model;
  }
}
class TypeNamespaceBuilder {
  constructor(qualifiedName, imports) {
    this.qualifiedName = qualifiedName;
    this.tn_1 = new TypeNamespaceSimple(this.qualifiedName, imports);
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.un_1 = tmp$ret$0;
  }
  wl() {
    return this.qualifiedName;
  }
  primitiveType(typeName) {
    return this.tn_1.findOwnedOrCreatePrimitiveTypeNamed(typeName);
  }
  enumType(typeName, literals) {
    var et = new EnumTypeSimple(this.tn_1, typeName, literals);
    this.tn_1.addDeclaration(et);
    return et;
  }
  collectionType(typeName, typeParams) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = this.tn_1.findOwnedOrCreateCollectionTypeNamed(typeName);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.typemodel.api.TypeNamespaceBuilder.collectionType.<anonymous>' call
    var tmp = tmp0_also.typeParameters;
    (isInterface(tmp, MutableList) ? tmp : THROW_CCE()).k1(typeParams);
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  }
  vn(typeName, init) {
    var b = new DataTypeBuilder(this.tn_1, this.un_1, typeName);
    init(b);
    var et = b.eo();
    return et;
  }
  dataType(typeName, init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = TypeNamespaceBuilder$dataType$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.vn(typeName, init);
  }
  unnamedSuperTypeTypeFor(subtypes) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(subtypes, 10));
    var tmp0_iterator = subtypes.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.typemodel.api.TypeNamespaceBuilder.unnamedSuperTypeTypeFor.<anonymous>' call
      var tmp0_subject = item;
      var tmp;
      if (typeof tmp0_subject === 'string') {
        tmp = ensureNotNull(this.tn_1.findOwnedOrCreateDataTypeNamed(item));
      } else {
        if (isInterface(tmp0_subject, TypeDefinition)) {
          tmp = item;
        } else {
          var tmp0_error = 'Cannot map to TypeDefinition: ' + toString(item);
          throw IllegalStateException.y1(toString(tmp0_error));
        }
      }
      tmp$ret$0 = tmp;
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    var sts = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(sts, 10));
    var tmp0_iterator_0 = sts.u();
    while (tmp0_iterator_0.h1()) {
      var item_0 = tmp0_iterator_0.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.typemodel.api.TypeNamespaceBuilder.unnamedSuperTypeTypeFor.<anonymous>' call
      tmp$ret$3 = item_0.instance();
      tmp0_mapTo_0.e1(tmp$ret$3);
    }
    tmp$ret$4 = tmp0_mapTo_0;
    tmp$ret$5 = tmp$ret$4;
    var t = this.tn_1.createUnnamedSuperTypeType(tmp$ret$5);
    return t;
  }
  build() {
    return this.tn_1;
  }
}
class TypeUsageReferenceBuilder {
  constructor(_namespace, type, nullable) {
    this._namespace = _namespace;
    this.type = type;
    this.nullable = nullable;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.fo_1 = tmp$ret$0;
  }
  go() {
    return this._namespace;
  }
  em() {
    return this.type;
  }
  ho() {
    return this.nullable;
  }
  primitiveRef(typeName) {
    this.fo_1.e1(this._namespace.createTypeInstance(typeName, emptyList(), this.nullable));
  }
  elementRef(typeName) {
    this.fo_1.e1(this._namespace.createTypeInstance(typeName, emptyList(), this.nullable));
  }
  unnamedSuperTypeOf(subtypeNames) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(subtypeNames.length);
    var indexedObject = subtypeNames;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.typemodel.api.TypeUsageReferenceBuilder.unnamedSuperTypeOf.<anonymous>' call
      tmp$ret$0 = this._namespace.createTypeInstance(item, emptyList(), false);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    var subtypes = tmp$ret$2;
    var t = this._namespace.createUnnamedSuperTypeType(subtypes);
    this.fo_1.e1(t.instance(emptyList(), this.nullable));
  }
  build() {
    return this.type.instance(this.fo_1, false);
  }
}
class TypeArgumentBuilder {
  constructor(_namespace) {
    this.io_1 = _namespace;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.jo_1 = tmp$ret$0;
  }
  ko(qualifiedTypeName, typeArguments) {
    var tab = new TypeArgumentBuilder(this.io_1);
    typeArguments(tab);
    var typeArgs = tab.build();
    var tref = this.io_1.createTypeInstance(qualifiedTypeName, typeArgs, false);
    this.jo_1.e1(tref);
    return tref;
  }
  typeArgument(qualifiedTypeName, typeArguments, $super) {
    var tmp;
    if (typeArguments === VOID) {
      tmp = TypeArgumentBuilder$typeArgument$lambda;
    } else {
      tmp = typeArguments;
    }
    typeArguments = tmp;
    return this.ko(qualifiedTypeName, typeArguments);
  }
  build() {
    return this.jo_1;
  }
}
class SubtypeListBuilder {
  constructor(_namespace, _typeReferences) {
    this._namespace = _namespace;
    this.lo_1 = _typeReferences;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp._subtypeList = tmp$ret$0;
  }
  go() {
    return this._namespace;
  }
  mo() {
    return this._subtypeList;
  }
  primitiveRef(typeName) {
    var ti = this._namespace.createTypeInstance(typeName, emptyList(), false);
    this._subtypeList.e1(ti);
  }
  elementRef(elementTypeName) {
    var ti = this._namespace.createTypeInstance(elementTypeName, emptyList(), false);
    this._subtypeList.e1(ti);
  }
  listType(nullable, init) {
    var collType = SimpleTypeModelStdLib_getInstance().List;
    var tb = new TypeUsageReferenceBuilder(this._namespace, collType, nullable);
    init(tb);
    this.lo_1.e1(tb);
    var tu = tb.build();
    this._subtypeList.e1(tu);
  }
  tupleType(init) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    var b = new TupleTypeBuilder(this._namespace, tmp$ret$0);
    init(b);
    var t = b.eo();
    this._subtypeList.e1(t.instance());
  }
  unnamedSuperTypeOf(subtypeNames) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(subtypeNames.length);
    var indexedObject = subtypeNames;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.typemodel.api.SubtypeListBuilder.unnamedSuperTypeOf.<anonymous>' call
      tmp$ret$0 = ensureNotNull(this._namespace.findOwnedOrCreateDataTypeNamed(item));
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    var sts = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(sts, 10));
    var tmp0_iterator = sts.u();
    while (tmp0_iterator.h1()) {
      var item_0 = tmp0_iterator.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.typemodel.api.SubtypeListBuilder.unnamedSuperTypeOf.<anonymous>' call
      tmp$ret$3 = item_0.instance();
      tmp0_mapTo_0.e1(tmp$ret$3);
    }
    tmp$ret$4 = tmp0_mapTo_0;
    tmp$ret$5 = tmp$ret$4;
    var t = this._namespace.createUnnamedSuperTypeType(tmp$ret$5);
    this._subtypeList.e1(t.instance());
  }
  unnamedSuperType(init) {
    var b = new SubtypeListBuilder(this._namespace, this.lo_1);
    init(b);
    var stu = b.build();
    var t = this._namespace.createUnnamedSuperTypeType(stu);
    this._subtypeList.e1(t.instance());
  }
  build() {
    return this._subtypeList;
  }
}
class StructuredTypeBuilder {
  constructor(_namespace, _typeReferences) {
    this.yo_1 = _namespace;
    this.zo_1 = _typeReferences;
    this.ap_1 = PropertyCharacteristic_COMPOSITE_getInstance();
    this.bp_1 = PropertyCharacteristic_REFERENCE_getInstance();
    this.cp_1 = PropertyCharacteristic_IDENTITY_getInstance();
    this.dp_1 = PropertyCharacteristic_MEMBER_getInstance();
    this.ep_1 = PropertyCharacteristic_CONSTRUCTOR_getInstance();
  }
  fp(characteristics, propertyName, typeName, typeArgs, isNullable, init) {
    var tab = new TypeArgumentBuilder(this.yo_1);
    init(tab);
    var btargs = tab.build();
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(typeArgs, 10));
    var tmp0_iterator = typeArgs.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.typemodel.api.StructuredTypeBuilder.propertyOf.<anonymous>' call
      tmp$ret$0 = this.yo_1.createTypeInstance(item, emptyList(), false);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    var atargs = tmp$ret$2;
    var targs = btargs.y() ? atargs : btargs;
    var ti = this.yo_1.createTypeInstance(typeName, targs, isNullable);
    return this.vo().appendProperty(propertyName, ti, characteristics);
  }
  gp(characteristics, propertyName, typeName, typeArgs, isNullable, init, $super) {
    typeArgs = typeArgs === VOID ? emptyList() : typeArgs;
    isNullable = isNullable === VOID ? false : isNullable;
    var tmp;
    if (init === VOID) {
      tmp = StructuredTypeBuilder$propertyOf$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return $super === VOID ? this.fp(characteristics, propertyName, typeName, typeArgs, isNullable, init) : $super.fp.call(this, characteristics, propertyName, typeName, typeArgs, isNullable, init);
  }
}
class DataTypeBuilder extends StructuredTypeBuilder {
  constructor(_namespace, _typeReferences, _elementName) {
    super(_namespace, _typeReferences);
    var tmp = this;
    var tmp_0 = _namespace.findOwnedOrCreateDataTypeNamed(_elementName);
    tmp.do_1 = isInterface(tmp_0, DataType) ? tmp_0 : THROW_CCE();
  }
  vo() {
    return this.do_1;
  }
  wo(parameters) {
    var tmp = this.do_1;
    var tmp_0 = (isInterface(tmp, DataType) ? tmp : THROW_CCE()).typeParameters;
    addAll(isInterface(tmp_0, MutableList) ? tmp_0 : THROW_CCE(), parameters);
  }
  xo(superTypes) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = superTypes;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'net.akehurst.language.typemodel.api.DataTypeBuilder.supertypes.<anonymous>' call
      this.do_1.addSupertype(element);
    }
  }
  eo() {
    return this.do_1;
  }
}
class TupleTypeBuilder extends StructuredTypeBuilder {
  constructor(_namespace, _typeReferences) {
    super(_namespace, _typeReferences);
    this.uo_1 = _namespace.createTupleType();
  }
  vo() {
    return this.uo_1;
  }
  eo() {
    return this.uo_1;
  }
}
class AnyValue {
  constructor(type) {
    this.hp_1 = type;
  }
  em() {
    return this.hp_1;
  }
  get type() {
    return this.em();
  }
  get asValue() {
    return this.ip();
  }
}
class PrimitiveValueAbstract extends AnyValue {
  constructor(type) {
    super(type);
    this.kp_1 = type;
  }
  em() {
    return this.kp_1;
  }
}
class StructuredValue extends AnyValue {
  constructor(type) {
    super(type);
    this.mp_1 = type;
  }
  em() {
    return this.mp_1;
  }
}
class TupleValue extends StructuredValue {
  constructor(type, asValue) {
    super(type);
    this.pp_1 = type;
    this.qp_1 = asValue;
  }
  em() {
    return this.pp_1;
  }
  ip() {
    return this.qp_1;
  }
  toString() {
    var tmp = this.qp_1.l3();
    return '{\n  ' + joinToString(tmp, '\n  ', VOID, VOID, VOID, VOID, TupleValue$toString$lambda) + '}';
  }
  hashCode() {
    return hashCode(this.qp_1);
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (!(tmp0_subject instanceof TupleValue)) {
      tmp = false;
    } else {
      if (equals(tmp0_subject, !equals(this.pp_1, other.pp_1))) {
        tmp = false;
      } else {
        tmp = equals(this.qp_1, other.qp_1);
      }
    }
    return tmp;
  }
}
class TypeNamespaceAbstract {
  constructor(imports) {
    this.bq_1 = 0;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp$ret$0 = HashMap.w4();
    tmp.cq_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.dq_1 = tmp$ret$1;
    this.eq_1 = toMutableList(imports);
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$2 = LinkedHashMap.n8();
    tmp_1.fq_1 = tmp$ret$2;
  }
  xl() {
    return this.eq_1;
  }
  yl() {
    return this.fq_1;
  }
  zl() {
    return this.allTypesByName.k3();
  }
  am() {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0_filterIsInstance = this.allTypesByName.k3();
    var tmp$ret$0;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var tmp0_filterIsInstanceTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filterIsInstance.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      if (!(element == null) ? isInterface(element, PrimitiveType) : false) {
        tmp0_filterIsInstanceTo.e1(element);
      }
    }
    tmp$ret$0 = tmp0_filterIsInstanceTo;
    tmp$ret$1 = tmp$ret$0;
    return toSet(tmp$ret$1);
  }
  bm() {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0_filterIsInstance = this.allTypesByName.k3();
    var tmp$ret$0;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var tmp0_filterIsInstanceTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filterIsInstance.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      if (!(element == null) ? isInterface(element, EnumType) : false) {
        tmp0_filterIsInstanceTo.e1(element);
      }
    }
    tmp$ret$0 = tmp0_filterIsInstanceTo;
    tmp$ret$1 = tmp$ret$0;
    return toSet(tmp$ret$1);
  }
  cm() {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0_filterIsInstance = this.allTypesByName.k3();
    var tmp$ret$0;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var tmp0_filterIsInstanceTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filterIsInstance.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      if (!(element == null) ? isInterface(element, CollectionType) : false) {
        tmp0_filterIsInstanceTo.e1(element);
      }
    }
    tmp$ret$0 = tmp0_filterIsInstanceTo;
    tmp$ret$1 = tmp$ret$0;
    return toSet(tmp$ret$1);
  }
  dm() {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0_filterIsInstance = this.allTypesByName.k3();
    var tmp$ret$0;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var tmp0_filterIsInstanceTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filterIsInstance.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      if (!(element == null) ? isInterface(element, DataType) : false) {
        tmp0_filterIsInstanceTo.e1(element);
      }
    }
    tmp$ret$0 = tmp0_filterIsInstanceTo;
    tmp$ret$1 = tmp$ret$0;
    return toSet(tmp$ret$1);
  }
  resolveImports(model) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.imports;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.typemodel.simple.TypeNamespaceAbstract.resolveImports.<anonymous>' call
      var tmp0_elvis_lhs = model.namespace.u3(element);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var tmp0_error = "import '" + element + "' cannot be resolved in the TypeModel '" + model.name + "'";
        throw IllegalStateException.y1(toString(tmp0_error));
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var ns = tmp;
      // Inline function 'kotlin.collections.set' call
      var tmp1_set = this.dq_1;
      tmp1_set.m3(element, ns);
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp1_forEach = this.dq_1.j3();
    var tmp0_iterator_0 = tmp1_forEach.u();
    while (tmp0_iterator_0.h1()) {
      var element_0 = tmp0_iterator_0.j1();
      // Inline function 'net.akehurst.language.typemodel.simple.TypeNamespaceAbstract.resolveImports.<anonymous>' call
      var tmp0_elvis_lhs_0 = model.namespace.u3(element_0);
      var tmp_0;
      if (tmp0_elvis_lhs_0 == null) {
        var tmp0_error_0 = "namespace '" + element_0 + "' is required but cannot be resolved in the TypeModel '" + model.name + "'";
        throw IllegalStateException.y1(toString(tmp0_error_0));
      } else {
        tmp_0 = tmp0_elvis_lhs_0;
      }
      var ns_0 = tmp_0;
      // Inline function 'kotlin.collections.set' call
      var tmp1_set_0 = this.dq_1;
      tmp1_set_0.m3(element_0, ns_0);
    }
  }
  isImported(qualifiedNamespaceName) {
    return this.imports.w(qualifiedNamespaceName);
  }
  addImport(qualifiedName) {
    var tmp = this.imports;
    (isInterface(tmp, MutableList) ? tmp : THROW_CCE()).e1(qualifiedName);
  }
  addDeclaration(decl) {
    if (this.allTypesByName.r3(decl.name)) {
      // Inline function 'kotlin.error' call
      var tmp0_error = "namespace '" + this.qualifiedName + "' already contains a declaration named '" + decl.name + "', cannot add another";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      var tmp0_subject = decl;
      if (isInterface(tmp0_subject, PrimitiveType)) {
        // Inline function 'kotlin.collections.set' call
        var tmp1_set = this.allTypesByName;
        var tmp2_set = decl.name;
        tmp1_set.m3(tmp2_set, decl);
      } else {
        if (isInterface(tmp0_subject, EnumType)) {
          // Inline function 'kotlin.collections.set' call
          var tmp3_set = this.allTypesByName;
          var tmp4_set = decl.name;
          tmp3_set.m3(tmp4_set, decl);
        } else {
          if (isInterface(tmp0_subject, UnnamedSuperTypeType))
          ;
          else {
            if (isInterface(tmp0_subject, StructuredType)) {
              var tmp1_subject = decl;
              if (isInterface(tmp1_subject, TupleType))
              ;
              else {
                if (isInterface(tmp1_subject, DataType)) {
                  // Inline function 'kotlin.collections.set' call
                  var tmp5_set = this.allTypesByName;
                  var tmp6_set = decl.name;
                  tmp5_set.m3(tmp6_set, decl);
                } else {
                  if (isInterface(tmp1_subject, CollectionType)) {
                    // Inline function 'kotlin.collections.set' call
                    var tmp7_set = this.allTypesByName;
                    var tmp8_set = decl.name;
                    tmp7_set.m3(tmp8_set, decl);
                  }
                }
              }
            } else {
              {
                var tmp9_error = "Cannot add declaration '" + decl + "'";
                throw IllegalStateException.y1(toString(tmp9_error));
              }
            }
          }
        }
      }
    }
  }
  findOwnedTypeNamed(typeName) {
    return this.allTypesByName.u3(typeName);
  }
  findTypeNamed(qualifiedOrImportedTypeName) {
    var ns = substringBeforeLast(qualifiedOrImportedTypeName, '.', '');
    var tn = substringAfterLast(qualifiedOrImportedTypeName, '.');
    var tmp0_subject = ns;
    var tmp;
    if (tmp0_subject === '') {
      var tmp1_elvis_lhs = this.findOwnedTypeNamed(tn);
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
          var tmp0_firstNotNullOfOrNull = this.imports;
          var tmp0_iterator = tmp0_firstNotNullOfOrNull.u();
          while (tmp0_iterator.h1()) {
            var element = tmp0_iterator.j1();
            var tmp$ret$0;
            // Inline function 'net.akehurst.language.typemodel.simple.TypeNamespaceAbstract.findTypeNamed.<anonymous>' call
            var tns = this.dq_1.u3(element);
            var tmp0_safe_receiver = tns;
            tmp$ret$0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.findOwnedTypeNamed(tn);
            var result = tmp$ret$0;
            if (!(result == null)) {
              tmp$ret$1 = result;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        tmp_0 = tmp$ret$1;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      var tmp2_elvis_lhs = this.dq_1.u3(ns);
      var tmp_1;
      if (tmp2_elvis_lhs == null) {
        var tmp1_error = "namespace '" + ns + "' not resolved in namespace '" + this.qualifiedName + "', have you called resolveImports() on the TypeModel and does it contain the required namespace?";
        throw IllegalStateException.y1(toString(tmp1_error));
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }
      var tns_0 = tmp_1;
      tmp = tns_0.findOwnedTypeNamed(tn);
    }
    return tmp;
  }
  findOrCreateSpecialTypeNamed(typeName) {
    var existing = this.findOwnedTypeNamed(typeName);
    var tmp;
    if (null == existing) {
      var t = new SpecialTypeSimple(this, typeName);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.allTypesByName;
      tmp0_set.m3(typeName, t);
      tmp = t;
    } else {
      tmp = existing instanceof SpecialTypeSimple ? existing : THROW_CCE();
    }
    return tmp;
  }
  findOwnedOrCreatePrimitiveTypeNamed(typeName) {
    var existing = this.findOwnedTypeNamed(typeName);
    var tmp;
    if (null == existing) {
      var t = new PrimitiveTypeSimple(this, typeName);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.allTypesByName;
      tmp0_set.m3(typeName, t);
      tmp = t;
    } else {
      tmp = (!(existing == null) ? isInterface(existing, PrimitiveType) : false) ? existing : THROW_CCE();
    }
    return tmp;
  }
  findOwnedOrCreateCollectionTypeNamed(typeName) {
    var existing = this.findOwnedTypeNamed(typeName);
    var tmp;
    if (null == existing) {
      var t = new CollectionTypeSimple(this, typeName);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.allTypesByName;
      tmp0_set.m3(typeName, t);
      tmp = t;
    } else {
      tmp = (!(existing == null) ? isInterface(existing, CollectionType) : false) ? existing : THROW_CCE();
    }
    return tmp;
  }
  findOwnedOrCreateDataTypeNamed(typeName) {
    var existing = this.findOwnedTypeNamed(typeName);
    var tmp;
    if (null == existing) {
      var t = new DataTypeSimple(this, typeName);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.allTypesByName;
      tmp0_set.m3(typeName, t);
      tmp = t;
    } else {
      tmp = (!(existing == null) ? isInterface(existing, DataType) : false) ? existing : THROW_CCE();
    }
    return tmp;
  }
  createUnnamedSuperTypeType(subtypes) {
    var existing = this.cq_1.u3(subtypes);
    var tmp;
    if (null == existing) {
      var tmp0_this = this;
      var tmp1 = tmp0_this.bq_1;
      tmp0_this.bq_1 = tmp1 + 1 | 0;
      var t = new UnnamedSuperTypeTypeSimple(this, tmp1, subtypes);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.cq_1;
      tmp0_set.m3(subtypes, t);
      tmp = t;
    } else {
      tmp = existing;
    }
    return tmp;
  }
  createTypeInstance(qualifiedOrImportedTypeName, typeArguments, isNullable) {
    var ns = substringBeforeLast(qualifiedOrImportedTypeName, '.', '');
    var tn = substringAfterLast(qualifiedOrImportedTypeName, '.');
    var tmp0_subject = ns;
    if (tmp0_subject === '')
    ;
    else {
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.dq_1;
      tmp0_set.m3(ns, null);
    }
    return new TypeInstanceSimple(this, qualifiedOrImportedTypeName, typeArguments, isNullable);
  }
  createTupleTypeInstance(type, arguments_0, nullable) {
    return new TupleTypeInstance(this, type, arguments_0, nullable);
  }
  createUnnamedSuperTypeTypeInstance(type, arguments_0, nullable) {
    return new UnnamedSuperTypeTypeInstance(this, type, arguments_0, nullable);
  }
  createTupleType() {
    return new TupleTypeSimple(this);
  }
  asString() {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.sortedBy' call
    var tmp0_sortedBy = this.allTypesByName.l3();
    var tmp$ret$0;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = TypeNamespaceAbstract$asString$lambda;
    tmp$ret$0 = new sam$kotlin_Comparator$0_0(tmp);
    tmp$ret$1 = sortedWith(tmp0_sortedBy, tmp$ret$0);
    var tmp_0 = tmp$ret$1;
    var types = joinToString(tmp_0, '\n  ', '  ', VOID, VOID, VOID, TypeNamespaceAbstract$asString$lambda_0(this));
    var tmp_1 = this.imports;
    var importstr = joinToString(tmp_1, '\n  ', '  ', VOID, VOID, VOID, TypeNamespaceAbstract$asString$lambda_1);
    var s = trimIndent("\nnamespace '" + this.qualifiedName + "' {\n" + importstr + '\n' + types + '\n}\n    ');
    return s;
  }
  hashCode() {
    return getStringHashCode(this.qualifiedName);
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (!(!(tmp0_subject == null) ? isInterface(tmp0_subject, TypeNamespace) : false)) {
      tmp = false;
    } else {
      tmp = this.qualifiedName === other.qualifiedName;
    }
    return tmp;
  }
  toString() {
    return this.qualifiedName;
  }
  get qualifiedName() {
    return this.wl();
  }
  get imports() {
    return this.xl();
  }
  get allTypesByName() {
    return this.yl();
  }
  get allTypes() {
    return this.zl();
  }
  get primitiveType() {
    return this.am();
  }
  get enumType() {
    return this.bm();
  }
  get collectionType() {
    return this.cm();
  }
  get elementType() {
    return this.dm();
  }
}
class SimpleTypeModelStdLib_0 extends TypeNamespaceAbstract {
  constructor() {
    SimpleTypeModelStdLib_instance = null;
    super(emptyList());
    SimpleTypeModelStdLib_instance = this;
    this.sn_1 = 'std';
    this.AnyType = super.findOrCreateSpecialTypeNamed('$Any');
    this.NothingType = super.findOrCreateSpecialTypeNamed('$Nothing');
    this.String = super.findOwnedOrCreatePrimitiveTypeNamed('String').instance();
    this.Boolean = super.findOwnedOrCreatePrimitiveTypeNamed('Boolean').instance();
    this.Integer = super.findOwnedOrCreatePrimitiveTypeNamed('Integer').instance();
    this.Real = super.findOwnedOrCreatePrimitiveTypeNamed('Real').instance();
    this.Timestamp = super.findOwnedOrCreatePrimitiveTypeNamed('Timestamp').instance();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = super.findOwnedOrCreateCollectionTypeNamed('List');
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.typemodel.simple.SimpleTypeModelStdLib.List.<anonymous>' call
    var tmp_0 = tmp0_also.typeParameters;
    (isInterface(tmp_0, MutableList) ? tmp_0 : THROW_CCE()).e1('E');
    tmp$ret$0 = tmp0_also;
    tmp.List = tmp$ret$0;
    var tmp_1 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.also' call
    var tmp0_also_0 = super.findOwnedOrCreateCollectionTypeNamed('ListSeparated');
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.typemodel.simple.SimpleTypeModelStdLib.ListSeparated.<anonymous>' call
    var tmp_2 = tmp0_also_0.typeParameters;
    (isInterface(tmp_2, MutableList) ? tmp_2 : THROW_CCE()).k1(listOf_0(['E', 'I']));
    tmp$ret$1 = tmp0_also_0;
    tmp_1.ListSeparated = tmp$ret$1;
    var tmp_3 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.also' call
    var tmp0_also_1 = super.findOwnedOrCreateCollectionTypeNamed('Set');
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.typemodel.simple.SimpleTypeModelStdLib.Set.<anonymous>' call
    var tmp_4 = tmp0_also_1.typeParameters;
    (isInterface(tmp_4, MutableList) ? tmp_4 : THROW_CCE()).e1('E');
    tmp$ret$2 = tmp0_also_1;
    tmp_3.Set = tmp$ret$2;
    var tmp_5 = this;
    var tmp$ret$3;
    // Inline function 'kotlin.also' call
    var tmp0_also_2 = super.findOwnedOrCreateCollectionTypeNamed('OrderedSet');
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.typemodel.simple.SimpleTypeModelStdLib.OrderedSet.<anonymous>' call
    var tmp_6 = tmp0_also_2.typeParameters;
    (isInterface(tmp_6, MutableList) ? tmp_6 : THROW_CCE()).e1('E');
    tmp$ret$3 = tmp0_also_2;
    tmp_5.OrderedSet = tmp$ret$3;
    var tmp_7 = this;
    var tmp$ret$4;
    // Inline function 'kotlin.also' call
    var tmp0_also_3 = super.findOwnedOrCreateCollectionTypeNamed('Map');
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.typemodel.simple.SimpleTypeModelStdLib.Map.<anonymous>' call
    var tmp_8 = tmp0_also_3.typeParameters;
    (isInterface(tmp_8, MutableList) ? tmp_8 : THROW_CCE()).k1(listOf_0(['K', 'V']));
    tmp$ret$4 = tmp0_also_3;
    tmp_7.Map = tmp$ret$4;
  }
  wl() {
    return this.sn_1;
  }
  sl() {
    return this.AnyType;
  }
  tl() {
    return this.NothingType;
  }
  rp() {
    return this.String;
  }
  sp() {
    return this.Boolean;
  }
  tp() {
    return this.Integer;
  }
  up() {
    return this.Real;
  }
  vp() {
    return this.Timestamp;
  }
  wp() {
    return this.List;
  }
  xp() {
    return this.ListSeparated;
  }
  yp() {
    return this.Set;
  }
  zp() {
    return this.OrderedSet;
  }
  aq() {
    return this.Map;
  }
}
class TypeModelSimpleAbstract {
  constructor(name) {
    this.gq_1 = name;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.hq_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$1 = ArrayList.i4();
    tmp_0.iq_1 = tmp$ret$1;
  }
  be() {
    return this.gq_1;
  }
  sl() {
    return SimpleTypeModelStdLib_getInstance().AnyType;
  }
  tl() {
    return SimpleTypeModelStdLib_getInstance().NothingType;
  }
  ul() {
    return this.hq_1;
  }
  vl() {
    return this.iq_1;
  }
  resolveImports() {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.allNamespace;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.typemodel.simple.TypeModelSimpleAbstract.resolveImports.<anonymous>' call
      element.resolveImports(this);
    }
  }
  addNamespace(ns) {
    if (this.namespace.r3(ns.qualifiedName)) {
      if (this.namespace.u3(ns.qualifiedName) === ns) {
      } else {
        // Inline function 'kotlin.error' call
        var tmp0_error = "TypeModel '" + this.name + "' already contains a namespace '" + ns.qualifiedName + "'";
        throw IllegalStateException.y1(toString(tmp0_error));
      }
    } else {
      // Inline function 'kotlin.collections.set' call
      var tmp = this.namespace;
      var tmp1_set = isInterface(tmp, MutableMap) ? tmp : THROW_CCE();
      var tmp2_set = ns.qualifiedName;
      tmp1_set.m3(tmp2_set, ns);
      var tmp_0 = this.allNamespace;
      (isInterface(tmp_0, MutableList) ? tmp_0 : THROW_CCE()).e1(ns);
    }
  }
  findFirstByNameOrNull(typeName) {
    var tmp0_iterator = this.allNamespace.u();
    while (tmp0_iterator.h1()) {
      var ns = tmp0_iterator.j1();
      var t = ns.findOwnedTypeNamed(typeName);
      if (!(null == t)) {
        return t;
      }
    }
    return null;
  }
  findByQualifiedNameOrNull(qualifiedName) {
    var tmp;
    if (!contains(qualifiedName, '.')) {
      tmp = this.findFirstByNameOrNull(qualifiedName);
    } else {
      var nsn = substringBefore(qualifiedName, '.');
      var tn = substringAfter(qualifiedName, '.');
      var tmp0_safe_receiver = this.namespace.u3(nsn);
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.findOwnedTypeNamed(tn);
    }
    return tmp;
  }
  asString() {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.sortedBy' call
    var tmp0_sortedBy = this.allNamespace;
    var tmp$ret$0;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = TypeModelSimpleAbstract$asString$lambda;
    tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
    tmp$ret$1 = sortedWith(tmp0_sortedBy, tmp$ret$0);
    var tmp_0 = tmp$ret$1;
    var ns = joinToString(tmp_0, '\n', VOID, VOID, VOID, VOID, TypeModelSimpleAbstract$asString$lambda_0);
    return "typemodel '" + this.name + "'\n" + ns;
  }
  get name() {
    return this.be();
  }
  get AnyType() {
    return this.sl();
  }
  get NothingType() {
    return this.tl();
  }
  get namespace() {
    return this.ul();
  }
  get allNamespace() {
    return this.vl();
  }
}
class TypeModelSimple extends TypeModelSimpleAbstract {}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.jq_1 = function_0;
  }
  rc(a, b) {
    return this.jq_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class TypeInstanceAbstract {
  notNullable() {
    return this.type.instance(this.typeArguments, false);
  }
  nullable() {
    return this.type.instance(this.typeArguments, true);
  }
  signature(context, currentDepth) {
    var tmp;
    Companion_getInstance();
    if (currentDepth >= 10) {
      tmp = '...';
    } else {
      var tmp_0;
      if (this.typeArguments.y()) {
        tmp_0 = '';
      } else {
        var tmp_1 = this.typeArguments;
        tmp_0 = '<' + joinToString(tmp_1, VOID, VOID, VOID, VOID, VOID, TypeInstanceAbstract$signature$lambda(context, currentDepth)) + '>';
      }
      var args = tmp_0;
      var tmp0_subject = this.isNullable;
      var n = tmp0_subject === true ? '?' : '';
      var name = this.typeArguments.y() ? this.type.signature(context, currentDepth + 1 | 0) : this.type.name;
      return name + args + n;
    }
    return tmp;
  }
  toString() {
    var tmp;
    if (this.typeArguments.y()) {
      tmp = '';
    } else {
      var tmp_0 = this.typeArguments;
      tmp = '<' + joinToString(tmp_0, VOID, VOID, VOID, VOID, VOID, TypeInstanceAbstract$toString$lambda) + '>';
    }
    var args = tmp;
    var tmp0_subject = this.isNullable;
    var n = tmp0_subject === true ? '?' : '';
    return this.type.name + args + n;
  }
  get namespace() {
    return this.ul();
  }
  get type() {
    return this.em();
  }
  get typeArguments() {
    return this.fm();
  }
  get isNullable() {
    return this.gm();
  }
}
class TypeInstanceSimple extends TypeInstanceAbstract {
  constructor(namespace, qualifiedOrImportedTypeName, typeArguments, isNullable) {
    super();
    this.kq_1 = namespace;
    this.qualifiedOrImportedTypeName = qualifiedOrImportedTypeName;
    this.lq_1 = typeArguments;
    this.mq_1 = isNullable;
    var tmp = this;
    tmp.nq_1 = lazy(TypeInstanceSimple$type$delegate$lambda(this));
  }
  ul() {
    return this.kq_1;
  }
  oq() {
    return this.qualifiedOrImportedTypeName;
  }
  fm() {
    return this.lq_1;
  }
  gm() {
    return this.mq_1;
  }
  em() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = type$factory();
    tmp$ret$0 = this.nq_1.p3();
    return tmp$ret$0;
  }
  hashCode() {
    return hashCode(listOf_0([this.qualifiedOrImportedTypeName, this.lq_1, this.mq_1]));
  }
  equals(other) {
    var tmp;
    if (!(other instanceof TypeInstanceSimple)) {
      tmp = false;
    } else {
      if (!(this.qualifiedOrImportedTypeName === other.qualifiedOrImportedTypeName)) {
        tmp = false;
      } else {
        if (!(this.mq_1 === other.mq_1)) {
          tmp = false;
        } else {
          if (!equals(this.lq_1, other.lq_1)) {
            tmp = false;
          } else {
            tmp = true;
          }
        }
      }
    }
    return tmp;
  }
}
class TupleTypeInstance extends TypeInstanceAbstract {
  constructor(namespace, type, typeArguments, isNullable) {
    super();
    this.pq_1 = namespace;
    this.qq_1 = type;
    this.rq_1 = typeArguments;
    this.sq_1 = isNullable;
  }
  ul() {
    return this.pq_1;
  }
  em() {
    return this.qq_1;
  }
  fm() {
    return this.rq_1;
  }
  gm() {
    return this.sq_1;
  }
  hashCode() {
    return hashCode(listOf_0([this.qq_1, this.rq_1, this.sq_1]));
  }
  equals(other) {
    var tmp;
    if (!(other instanceof TypeInstanceSimple)) {
      tmp = false;
    } else {
      if (!equals(this.qq_1, other.type)) {
        tmp = false;
      } else {
        if (!(this.sq_1 === other.mq_1)) {
          tmp = false;
        } else {
          if (!equals(this.rq_1, other.lq_1)) {
            tmp = false;
          } else {
            tmp = true;
          }
        }
      }
    }
    return tmp;
  }
}
class UnnamedSuperTypeTypeInstance extends TypeInstanceAbstract {
  constructor(namespace, type, typeArguments, isNullable) {
    super();
    this.tq_1 = namespace;
    this.uq_1 = type;
    this.vq_1 = typeArguments;
    this.wq_1 = isNullable;
  }
  ul() {
    return this.tq_1;
  }
  em() {
    return this.uq_1;
  }
  fm() {
    return this.vq_1;
  }
  gm() {
    return this.wq_1;
  }
  hashCode() {
    return hashCode(listOf_0([this.uq_1, this.vq_1, this.wq_1]));
  }
  equals(other) {
    var tmp;
    if (!(other instanceof TypeInstanceSimple)) {
      tmp = false;
    } else {
      if (!equals(this.uq_1, other.type)) {
        tmp = false;
      } else {
        if (!(this.wq_1 === other.mq_1)) {
          tmp = false;
        } else {
          if (!equals(this.vq_1, other.lq_1)) {
            tmp = false;
          } else {
            tmp = true;
          }
        }
      }
    }
    return tmp;
  }
}
class TypeNamespaceSimple extends TypeNamespaceAbstract {
  constructor(qualifiedName, imports) {
    super(imports);
    this.cr_1 = qualifiedName;
  }
  wl() {
    return this.cr_1;
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.dr_1 = function_0;
  }
  rc(a, b) {
    return this.dr_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
    this.maxDepth = 10;
  }
  er() {
    return this.maxDepth;
  }
}
class TypeDefinitionSimpleAbstract {
  constructor() {
    Companion_getInstance();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.fr_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.gr_1 = tmp$ret$1;
  }
  wl() {
    return this.namespace.qualifiedName + '.' + this.name;
  }
  hm() {
    return this.fr_1;
  }
  hr(_set____db54di) {
    this.gr_1 = _set____db54di;
  }
  im() {
    return this.gr_1;
  }
  km(arguments_0, nullable) {
    return this.namespace.createTypeInstance(this.name, arguments_0, nullable);
  }
  asString(context) {
    return this.signature(context, 0);
  }
  get qualifiedName() {
    return this.wl();
  }
  get typeParameters() {
    return this.hm();
  }
  get metaInfo() {
    return this.im();
  }
  set metaInfo(value) {
    this.hr(value);
  }
  get namespace() {
    return this.ul();
  }
  get name() {
    return this.be();
  }
  static get Companion() {
    return Companion_getInstance();
  }
}
class SpecialTypeSimple extends TypeDefinitionSimpleAbstract {
  constructor(namespace, name) {
    super();
    this.kr_1 = namespace;
    this.lr_1 = name;
  }
  ul() {
    return this.kr_1;
  }
  be() {
    return this.lr_1;
  }
  jm(context, currentDepth) {
    return null == context ? this.qualifiedName : equals(context, this.kr_1) ? this.lr_1 : context.isImported(this.kr_1.qualifiedName) ? this.lr_1 : this.qualifiedName;
  }
  asString(context) {
    return 'special ' + this.signature(context);
  }
  hashCode() {
    return getStringHashCode(this.qualifiedName);
  }
  equals(other) {
    var tmp;
    if (!(other instanceof SpecialTypeSimple)) {
      tmp = false;
    } else {
      if (!(this.qualifiedName === other.qualifiedName)) {
        tmp = false;
      } else {
        tmp = true;
      }
    }
    return tmp;
  }
  toString() {
    return this.qualifiedName;
  }
}
class PrimitiveTypeSimple extends TypeDefinitionSimpleAbstract {
  constructor(namespace, name) {
    super();
    this.or_1 = namespace;
    this.pr_1 = name;
  }
  ul() {
    return this.or_1;
  }
  be() {
    return this.pr_1;
  }
  jm(context, currentDepth) {
    return null == context ? this.qualifiedName : equals(context, this.or_1) ? this.pr_1 : context.isImported(this.or_1.qualifiedName) ? this.pr_1 : this.qualifiedName;
  }
  asString(context) {
    return 'primitive ' + this.signature(context);
  }
  hashCode() {
    return getStringHashCode(this.qualifiedName);
  }
  equals(other) {
    var tmp;
    if (!(!(other == null) ? isInterface(other, PrimitiveType) : false)) {
      tmp = false;
    } else {
      if (!(this.qualifiedName === other.qualifiedName)) {
        tmp = false;
      } else {
        tmp = true;
      }
    }
    return tmp;
  }
  toString() {
    return this.qualifiedName;
  }
}
class EnumTypeSimple extends TypeDefinitionSimpleAbstract {
  constructor(namespace, name, literals) {
    super();
    this.sr_1 = namespace;
    this.tr_1 = name;
    this.ur_1 = literals;
  }
  ul() {
    return this.sr_1;
  }
  be() {
    return this.tr_1;
  }
  lm() {
    return this.ur_1;
  }
  jm(context, currentDepth) {
    return null == context ? this.qualifiedName : equals(context, this.sr_1) ? this.tr_1 : context.isImported(this.sr_1.qualifiedName) ? this.tr_1 : this.qualifiedName;
  }
  asString(context) {
    return 'enum ' + this.signature(context);
  }
  hashCode() {
    return getStringHashCode(this.qualifiedName);
  }
  equals(other) {
    var tmp;
    if (!(!(other == null) ? isInterface(other, PrimitiveType) : false)) {
      tmp = false;
    } else {
      if (!(this.qualifiedName === other.qualifiedName)) {
        tmp = false;
      } else {
        tmp = true;
      }
    }
    return tmp;
  }
  toString() {
    return this.qualifiedName;
  }
  get literals() {
    return this.lm();
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    this.NAME = '$UnnamedSuperTypeType';
  }
  vr() {
    return this.NAME;
  }
}
class sam$kotlin_Comparator$0_1 {
  constructor(function_0) {
    this.wr_1 = function_0;
  }
  rc(a, b) {
    return this.wr_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class UnnamedSuperTypeTypeSimple extends TypeDefinitionSimpleAbstract {
  constructor(namespace, id, subtypes) {
    Companion_getInstance_0();
    super();
    this.zr_1 = namespace;
    this.as_1 = id;
    this.bs_1 = subtypes;
    this.cs_1 = Companion_getInstance_0().NAME;
  }
  ul() {
    return this.zr_1;
  }
  en() {
    return this.as_1;
  }
  qm() {
    return this.bs_1;
  }
  be() {
    return this.cs_1;
  }
  km(arguments_0, nullable) {
    return this.zr_1.createUnnamedSuperTypeTypeInstance(this, arguments_0, nullable);
  }
  jm(context, currentDepth) {
    var tmp;
    Companion_getInstance();
    if (currentDepth >= 10) {
      tmp = '...';
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.collections.sortedBy' call
      var tmp0_sortedBy = this.bs_1;
      var tmp$ret$0;
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = UnnamedSuperTypeTypeSimple$signature$lambda(context, currentDepth);
      tmp$ret$0 = new sam$kotlin_Comparator$0_1(tmp_0);
      tmp$ret$1 = sortedWith(tmp0_sortedBy, tmp$ret$0);
      var tmp_1 = tmp$ret$1;
      tmp = '? supertypeOf ' + joinToString(tmp_1, ' | ', '(', ')', VOID, VOID, UnnamedSuperTypeTypeSimple$signature$lambda_0(context, currentDepth));
    }
    return tmp;
  }
  asString(context) {
    return 'unnamed ' + this.signature(context);
  }
  hashCode() {
    return this.as_1;
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, UnnamedSuperTypeType) : false) {
      tmp = other.id === this.as_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return this.cs_1;
  }
  get id() {
    return this.en();
  }
  get subtypes() {
    return this.qm();
  }
  static get Companion() {
    return Companion_getInstance_0();
  }
}
class StructuredTypeSimpleAbstract extends TypeDefinitionSimpleAbstract {
  constructor() {
    super();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.fs_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.gs_1 = tmp$ret$1;
  }
  mm() {
    return this.fs_1;
  }
  nm() {
    return this.gs_1;
  }
  getPropertyByIndex(i) {
    return this.properties.u3(i);
  }
  propertiesWithCharacteristic(chr) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this.property.k3();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.typemodel.simple.StructuredTypeSimpleAbstract.propertiesWithCharacteristic.<anonymous>' call
      tmp$ret$0 = element.characteristics.w(chr);
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
  om(name, type, characteristics, index) {
    var childIndex = index >= 0 ? index : this.property.o();
    var pd = new PropertyDeclarationSimple(this, name, type, characteristics, childIndex);
    addProperty(this, pd);
    return pd;
  }
  get property() {
    return this.mm();
  }
  get properties() {
    return this.nm();
  }
  get namespace() {
    return this.ul();
  }
  get name() {
    return this.be();
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.NAME = '$TupleType';
  }
  vr() {
    return this.NAME;
  }
}
class TupleTypeSimple extends StructuredTypeSimpleAbstract {
  constructor(namespace) {
    Companion_getInstance_1();
    super();
    this.ls_1 = namespace;
    this.ms_1 = Companion_getInstance_1().NAME;
  }
  ul() {
    return this.ls_1;
  }
  static new_net_akehurst_language_typemodel_simple_TupleTypeSimple(namespace, init) {
    Companion_getInstance_1();
    var $this = new TupleTypeSimple(namespace);
    init($this);
    return $this;
  }
  be() {
    return this.ms_1;
  }
  l3() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.properties.k3();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.typemodel.simple.TupleTypeSimple.<get-entries>.<anonymous>' call
      tmp$ret$0 = new Pair(item.name, item.typeInstance);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
  km(arguments_0, nullable) {
    return this.ls_1.createTupleTypeInstance(this, arguments_0, nullable);
  }
  jm(context, currentDepth) {
    var tmp;
    Companion_getInstance();
    if (currentDepth >= 10) {
      tmp = '...';
    } else {
      var tmp_0 = this.properties.k3();
      tmp = this.ms_1 + '<' + joinToString(tmp_0, VOID, VOID, VOID, VOID, VOID, TupleTypeSimple$signature$lambda(context, currentDepth)) + '>';
    }
    return tmp;
  }
  asString(context) {
    return 'tuple ' + this.signature(context);
  }
  hashCode() {
    return 0;
  }
  equals(other) {
    var tmp;
    if (!(!(other == null) ? isInterface(other, TupleType) : false)) {
      tmp = false;
    } else {
      if (!equals(this.entries, other.entries)) {
        tmp = false;
      } else {
        tmp = true;
      }
    }
    return tmp;
  }
  toString() {
    var tmp = this.properties.k3();
    return 'Tuple<' + joinToString(tmp, VOID, VOID, VOID, VOID, VOID, TupleTypeSimple$toString$lambda) + '>';
  }
  get entries() {
    return this.l3();
  }
  static get Companion() {
    return Companion_getInstance_1();
  }
}
class sam$kotlin_Comparator$0_2 {
  constructor(function_0) {
    this.ns_1 = function_0;
  }
  rc(a, b) {
    return this.ns_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class DataTypeSimple extends StructuredTypeSimpleAbstract {
  constructor(namespace, name) {
    super();
    this.ss_1 = namespace;
    this.ts_1 = name;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.us_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$1 = ArrayList.i4();
    tmp_0.vs_1 = tmp$ret$1;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$2 = ArrayList.i4();
    tmp_1.ws_1 = tmp$ret$2;
  }
  ul() {
    return this.ss_1;
  }
  be() {
    return this.ts_1;
  }
  xs(_set____db54di) {
    this.us_1 = _set____db54di;
  }
  hm() {
    return this.us_1;
  }
  pm() {
    return this.vs_1;
  }
  qm() {
    return this.ws_1;
  }
  rm() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this.vs_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.typemodel.simple.DataTypeSimple.<get-allSuperTypes>.<anonymous>' call
      var tmp = element.type;
      tmp$ret$0 = (isInterface(tmp, DataType) ? tmp : THROW_CCE()).allSuperTypes;
      var list = tmp$ret$0;
      addAll_0(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return plus(this.vs_1, tmp$ret$2);
  }
  sm() {
    var tmp$ret$5;
    // Inline function 'kotlin.collections.associateBy' call
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this.vs_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.typemodel.simple.DataTypeSimple.<get-allProperty>.<anonymous>' call
      var tmp = element.type;
      tmp$ret$0 = (isInterface(tmp, DataType) ? tmp : THROW_CCE()).allProperty.k3();
      var list = tmp$ret$0;
      addAll_0(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    var tmp1_associateBy = tmp$ret$2;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp1_associateBy, 10)), 16);
    var tmp$ret$4;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo = LinkedHashMap.o8(capacity);
    var tmp0_iterator_0 = tmp1_associateBy.u();
    while (tmp0_iterator_0.h1()) {
      var element_0 = tmp0_iterator_0.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.typemodel.simple.DataTypeSimple.<get-allProperty>.<anonymous>' call
      tmp$ret$3 = element_0.name;
      tmp0_associateByTo.m3(tmp$ret$3, element_0);
    }
    tmp$ret$4 = tmp0_associateByTo;
    tmp$ret$5 = tmp$ret$4;
    return plus_0(tmp$ret$5, this.property);
  }
  jm(context, currentDepth) {
    return null == context ? this.qualifiedName : equals(context, this.ss_1) ? this.ts_1 : context.isImported(this.ss_1.qualifiedName) ? this.ts_1 : this.qualifiedName;
  }
  addSupertype(qualifiedTypeName) {
    var ti = this.ss_1.createTypeInstance(qualifiedTypeName, emptyList(), false);
    var tmp = this.vs_1;
    (isInterface(tmp, MutableList) ? tmp : THROW_CCE()).e1(ti);
  }
  addSubtype(qualifiedTypeName) {
    var ti = this.ss_1.createTypeInstance(qualifiedTypeName, emptyList(), false);
    var tmp = this.ws_1;
    (isInterface(tmp, MutableList) ? tmp : THROW_CCE()).e1(ti);
  }
  asString(context) {
    var tmp;
    if (this.vs_1.y()) {
      tmp = '';
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.collections.sortedBy' call
      var tmp0_sortedBy = this.vs_1;
      var tmp$ret$0;
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = DataTypeSimple$asString$lambda(context);
      tmp$ret$0 = new sam$kotlin_Comparator$0_2(tmp_0);
      tmp$ret$1 = sortedWith(tmp0_sortedBy, tmp$ret$0);
      var tmp_1 = tmp$ret$1;
      tmp = ' : ' + joinToString(tmp_1, VOID, VOID, VOID, VOID, VOID, DataTypeSimple$asString$lambda_0(context));
    }
    var sups = tmp;
    var tmp$ret$3;
    // Inline function 'kotlin.collections.sortedBy' call
    var tmp1_sortedBy = this.property.k3();
    var tmp$ret$2;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = DataTypeSimple$asString$lambda_1;
    tmp$ret$2 = new sam$kotlin_Comparator$0_2(tmp_2);
    tmp$ret$3 = sortedWith(tmp1_sortedBy, tmp$ret$2);
    var tmp_3 = tmp$ret$3;
    var props = joinToString(tmp_3, '\n    ', VOID, VOID, VOID, VOID, DataTypeSimple$asString$lambda_2(context));
    return 'datatype ' + this.ts_1 + sups + ' {\n    ' + props + '\n  }';
  }
  hashCode() {
    return getStringHashCode(this.qualifiedName);
  }
  equals(other) {
    var tmp;
    if (!(!(other == null) ? isInterface(other, DataType) : false)) {
      tmp = false;
    } else {
      if (!(this.qualifiedName === other.qualifiedName)) {
        tmp = false;
      } else {
        tmp = true;
      }
    }
    return tmp;
  }
  toString() {
    return this.qualifiedName;
  }
  get typeParameters() {
    return this.hm();
  }
  set typeParameters(value) {
    this.xs(value);
  }
  get supertypes() {
    return this.pm();
  }
  get subtypes() {
    return this.qm();
  }
  get allSuperTypes() {
    return this.rm();
  }
  get allProperty() {
    return this.sm();
  }
}
class CollectionTypeSimple extends StructuredTypeSimpleAbstract {
  constructor(namespace, name, typeParameters) {
    var tmp;
    if (typeParameters === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp$ret$0 = ArrayList.i4();
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = typeParameters;
    }
    typeParameters = tmp;
    super();
    this.ct_1 = namespace;
    this.dt_1 = name;
    this.et_1 = typeParameters;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp$ret$1 = LinkedHashSet.r8();
    tmp_0.ft_1 = tmp$ret$1;
  }
  ul() {
    return this.ct_1;
  }
  be() {
    return this.dt_1;
  }
  gt(_set____db54di) {
    this.et_1 = _set____db54di;
  }
  hm() {
    return this.et_1;
  }
  pm() {
    return this.ft_1;
  }
  fn() {
    return this.dt_1 === 'Array';
  }
  gn() {
    return this.dt_1 === 'List';
  }
  hn() {
    return this.dt_1 === 'Set';
  }
  in() {
    return this.dt_1 === 'Map';
  }
  jm(context, currentDepth) {
    return null == context ? this.qualifiedName : equals(context, this.ct_1) ? this.dt_1 : context.isImported(this.ct_1.qualifiedName) ? this.dt_1 : this.qualifiedName;
  }
  asString(context) {
    return 'collection ' + this.signature(context);
  }
  get typeParameters() {
    return this.hm();
  }
  set typeParameters(value) {
    this.gt(value);
  }
  get supertypes() {
    return this.pm();
  }
  get isArray() {
    return this.fn();
  }
  get isList() {
    return this.gn();
  }
  get isSet() {
    return this.hn();
  }
  get isMap() {
    return this.in();
  }
}
class PropertyDeclarationSimple {
  constructor(owner, name, typeInstance, characteristics, index) {
    this.ht_1 = owner;
    this.it_1 = name;
    this.jt_1 = typeInstance;
    this.kt_1 = characteristics;
    this.lt_1 = index;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.mt_1 = tmp$ret$0;
  }
  tm() {
    return this.ht_1;
  }
  be() {
    return this.it_1;
  }
  um() {
    return this.jt_1;
  }
  vm() {
    return this.kt_1;
  }
  wm() {
    return this.lt_1;
  }
  hr(_set____db54di) {
    this.mt_1 = _set____db54di;
  }
  im() {
    return this.mt_1;
  }
  ym() {
    return this.kt_1.w(PropertyCharacteristic_COMPOSITE_getInstance());
  }
  xm() {
    return this.kt_1.w(PropertyCharacteristic_REFERENCE_getInstance());
  }
  an() {
    return this.kt_1.w(PropertyCharacteristic_CONSTRUCTOR_getInstance());
  }
  zm() {
    return this.kt_1.w(PropertyCharacteristic_IDENTITY_getInstance());
  }
  bn() {
    return this.kt_1.w(PropertyCharacteristic_MEMBER_getInstance());
  }
  hashCode() {
    return getObjectHashCode(this);
  }
  equals(other) {
    return this === other;
  }
  toString() {
    var nullable = this.jt_1.isNullable ? '?' : '';
    var chrsStr = this.kt_1.y() ? '' : joinToString(this.kt_1, VOID, ' {', '}');
    return this.ht_1.name + '.' + this.it_1 + ': ' + this.jt_1.type.name + nullable + ' [' + this.lt_1 + ']' + chrsStr;
  }
  get owner() {
    return this.tm();
  }
  get name() {
    return this.be();
  }
  get typeInstance() {
    return this.um();
  }
  get characteristics() {
    return this.vm();
  }
  get index() {
    return this.wm();
  }
  get metaInfo() {
    return this.im();
  }
  set metaInfo(value) {
    this.hr(value);
  }
  get isComposite() {
    return this.ym();
  }
  get isReference() {
    return this.xm();
  }
  get isConstructor() {
    return this.an();
  }
  get isIdentity() {
    return this.zm();
  }
  get isMember() {
    return this.bn();
  }
}
//endregion
var PropertyCharacteristic_REFERENCE_instance;
var PropertyCharacteristic_COMPOSITE_instance;
var PropertyCharacteristic_IDENTITY_instance;
var PropertyCharacteristic_CONSTRUCTOR_instance;
var PropertyCharacteristic_MEMBER_instance;
function values() {
  return [PropertyCharacteristic_REFERENCE_getInstance(), PropertyCharacteristic_COMPOSITE_getInstance(), PropertyCharacteristic_IDENTITY_getInstance(), PropertyCharacteristic_CONSTRUCTOR_getInstance(), PropertyCharacteristic_MEMBER_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'REFERENCE':
      return PropertyCharacteristic_REFERENCE_getInstance();
    case 'COMPOSITE':
      return PropertyCharacteristic_COMPOSITE_getInstance();
    case 'IDENTITY':
      return PropertyCharacteristic_IDENTITY_getInstance();
    case 'CONSTRUCTOR':
      return PropertyCharacteristic_CONSTRUCTOR_getInstance();
    case 'MEMBER':
      return PropertyCharacteristic_MEMBER_getInstance();
    default:
      PropertyCharacteristic_initEntries();
      THROW_ISE();
      break;
  }
}
var PropertyCharacteristic_entriesInitialized;
function PropertyCharacteristic_initEntries() {
  if (PropertyCharacteristic_entriesInitialized)
    return Unit_getInstance();
  PropertyCharacteristic_entriesInitialized = true;
  PropertyCharacteristic_REFERENCE_instance = new PropertyCharacteristic('REFERENCE', 0);
  PropertyCharacteristic_COMPOSITE_instance = new PropertyCharacteristic('COMPOSITE', 1);
  PropertyCharacteristic_IDENTITY_instance = new PropertyCharacteristic('IDENTITY', 2);
  PropertyCharacteristic_CONSTRUCTOR_instance = new PropertyCharacteristic('CONSTRUCTOR', 3);
  PropertyCharacteristic_MEMBER_instance = new PropertyCharacteristic('MEMBER', 4);
}
function PropertyCharacteristic_REFERENCE_getInstance() {
  PropertyCharacteristic_initEntries();
  return PropertyCharacteristic_REFERENCE_instance;
}
function PropertyCharacteristic_COMPOSITE_getInstance() {
  PropertyCharacteristic_initEntries();
  return PropertyCharacteristic_COMPOSITE_instance;
}
function PropertyCharacteristic_IDENTITY_getInstance() {
  PropertyCharacteristic_initEntries();
  return PropertyCharacteristic_IDENTITY_instance;
}
function PropertyCharacteristic_CONSTRUCTOR_getInstance() {
  PropertyCharacteristic_initEntries();
  return PropertyCharacteristic_CONSTRUCTOR_instance;
}
function PropertyCharacteristic_MEMBER_getInstance() {
  PropertyCharacteristic_initEntries();
  return PropertyCharacteristic_MEMBER_instance;
}
function typeModel(name, resolveImports, namespaces, init) {
  namespaces = namespaces === VOID ? listOf(SimpleTypeModelStdLib_getInstance()) : namespaces;
  var b = new TypeModelBuilder(name, resolveImports, namespaces);
  init(b);
  var m = b.build();
  return m;
}
function TypeNamespaceBuilder$dataType$lambda($this$null) {
  return Unit_getInstance();
}
function TypeArgumentBuilder$typeArgument$lambda($this$null) {
  return Unit_getInstance();
}
function StructuredTypeBuilder$propertyOf$lambda($this$null) {
  return Unit_getInstance();
}
function TupleValue$toString$lambda(it) {
  return it.o3() + '=' + toString(it.p3());
}
var SimpleTypeModelStdLib_instance;
function SimpleTypeModelStdLib_getInstance() {
  if (SimpleTypeModelStdLib_instance === VOID)
    new SimpleTypeModelStdLib_0();
  return SimpleTypeModelStdLib_instance;
}
function TypeModelSimpleAbstract$asString$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.typemodel.simple.TypeModelSimpleAbstract.asString.<anonymous>' call
  var tmp = a.qualifiedName;
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.typemodel.simple.TypeModelSimpleAbstract.asString.<anonymous>' call
  tmp$ret$1 = b.qualifiedName;
  return compareValues(tmp, tmp$ret$1);
}
function TypeModelSimpleAbstract$asString$lambda_0(it) {
  return it.asString();
}
function TypeInstanceAbstract$signature$lambda($context, $currentDepth) {
  return function (it) {
    return it.signature($context, $currentDepth + 1 | 0);
  };
}
function TypeInstanceAbstract$toString$lambda(it) {
  return toString(it);
}
function TypeInstanceSimple$type$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.kq_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "Cannot resolve TypeDefinition '" + this$0.qualifiedOrImportedTypeName + "', namespace is not set";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ns = tmp;
    var tmp1_elvis_lhs = ns.findTypeNamed(this$0.qualifiedOrImportedTypeName);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp1_error = "Cannot resolve TypeDefinition '" + this$0.qualifiedOrImportedTypeName + "', not found in namespace '" + ns.qualifiedName + "'. Is an import needed?";
      throw IllegalStateException.y1(toString(tmp1_error));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
}
function TypeNamespaceAbstract$asString$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.typemodel.simple.TypeNamespaceAbstract.asString.<anonymous>' call
  var tmp = a.o3();
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.typemodel.simple.TypeNamespaceAbstract.asString.<anonymous>' call
  tmp$ret$1 = b.o3();
  return compareValues(tmp, tmp$ret$1);
}
function TypeNamespaceAbstract$asString$lambda_0(this$0) {
  return function (it) {
    return it.p3().asString(this$0);
  };
}
function TypeNamespaceAbstract$asString$lambda_1(it) {
  return 'import ' + it + '.*';
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function UnnamedSuperTypeTypeSimple$signature$lambda($context, $currentDepth) {
  return function (a, b) {
    var tmp$ret$2;
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.typemodel.simple.UnnamedSuperTypeTypeSimple.signature.<anonymous>' call
    tmp$ret$0 = a.signature($context, $currentDepth + 1 | 0);
    var tmp = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'net.akehurst.language.typemodel.simple.UnnamedSuperTypeTypeSimple.signature.<anonymous>' call
    tmp$ret$1 = b.signature($context, $currentDepth + 1 | 0);
    tmp$ret$2 = compareValues(tmp, tmp$ret$1);
    return tmp$ret$2;
  };
}
function UnnamedSuperTypeTypeSimple$signature$lambda_0($context, $currentDepth) {
  return function (it) {
    return it.signature($context, $currentDepth + 1 | 0);
  };
}
function addProperty($this, propertyDeclaration) {
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.property;
  var tmp1_set = propertyDeclaration.name;
  tmp0_set.m3(tmp1_set, propertyDeclaration);
  // Inline function 'kotlin.collections.set' call
  var tmp2_set = $this.properties;
  var tmp3_set = propertyDeclaration.index;
  tmp2_set.m3(tmp3_set, propertyDeclaration);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function TupleTypeSimple$signature$lambda($context, $currentDepth) {
  return function (it) {
    return it.name + ':' + it.typeInstance.signature($context, $currentDepth + 1 | 0);
  };
}
function TupleTypeSimple$toString$lambda(it) {
  return it.name + ':' + it.typeInstance;
}
function DataTypeSimple$asString$lambda($context) {
  return function (a, b) {
    var tmp$ret$2;
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.typemodel.simple.DataTypeSimple.asString.<anonymous>' call
    tmp$ret$0 = a.signature($context, 0);
    var tmp = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'net.akehurst.language.typemodel.simple.DataTypeSimple.asString.<anonymous>' call
    tmp$ret$1 = b.signature($context, 0);
    tmp$ret$2 = compareValues(tmp, tmp$ret$1);
    return tmp$ret$2;
  };
}
function DataTypeSimple$asString$lambda_0($context) {
  return function (it) {
    return it.signature($context, 0);
  };
}
function DataTypeSimple$asString$lambda_1(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.typemodel.simple.DataTypeSimple.asString.<anonymous>' call
  var tmp = a.index;
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.typemodel.simple.DataTypeSimple.asString.<anonymous>' call
  tmp$ret$1 = b.index;
  return compareValues(tmp, tmp$ret$1);
}
function DataTypeSimple$asString$lambda$lambda(it) {
  var tmp;
  switch (it.bc_1) {
    case 2:
      tmp = 'val';
      break;
    case 0:
      tmp = 'ref';
      break;
    case 1:
      tmp = 'cmp';
      break;
    case 3:
      tmp = 'cns';
      break;
    case 4:
      tmp = 'var';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function DataTypeSimple$asString$lambda_2($context) {
  return function (it) {
    var psig = it.typeInstance.signature($context, 0);
    var tmp = it.characteristics;
    var chrs = joinToString(tmp, VOID, '{', '}', VOID, VOID, DataTypeSimple$asString$lambda$lambda);
    return it.name + ':' + psig + ' ' + chrs;
  };
}
function type$factory() {
  return getPropertyCallableRef('type', 1, KProperty1, function (receiver) {
    return receiver.type;
  }, null);
}
//region block: post-declaration
setMetadataFor(TypeModel, 'TypeModel', interfaceMeta);
setMetadataFor(TypeNamespace, 'TypeNamespace', interfaceMeta);
setMetadataFor(TypeInstance, 'TypeInstance', interfaceMeta);
setMetadataFor(TypeDefinition, 'TypeDefinition', interfaceMeta);
setMetadataFor(PrimitiveType, 'PrimitiveType', interfaceMeta, VOID, [TypeDefinition]);
setMetadataFor(EnumType, 'EnumType', interfaceMeta, VOID, [TypeDefinition]);
setMetadataFor(StructuredType, 'StructuredType', interfaceMeta, VOID, [TypeDefinition]);
setMetadataFor(TupleType, 'TupleType', interfaceMeta, VOID, [StructuredType]);
setMetadataFor(DataType, 'DataType', interfaceMeta, VOID, [StructuredType]);
setMetadataFor(PropertyDeclaration, 'PropertyDeclaration', interfaceMeta);
setMetadataFor(PropertyCharacteristic, 'PropertyCharacteristic', classMeta);
setMetadataFor(UnnamedSuperTypeType, 'UnnamedSuperTypeType', interfaceMeta, VOID, [TypeDefinition]);
setMetadataFor(CollectionType, 'CollectionType', interfaceMeta, VOID, [StructuredType]);
setMetadataFor(TypeModelBuilder, 'TypeModelBuilder', classMeta);
setMetadataFor(TypeNamespaceBuilder, 'TypeNamespaceBuilder', classMeta);
setMetadataFor(TypeUsageReferenceBuilder, 'TypeUsageReferenceBuilder', classMeta);
setMetadataFor(TypeArgumentBuilder, 'TypeArgumentBuilder', classMeta);
setMetadataFor(SubtypeListBuilder, 'SubtypeListBuilder', classMeta);
setMetadataFor(StructuredTypeBuilder, 'StructuredTypeBuilder', classMeta);
setMetadataFor(DataTypeBuilder, 'DataTypeBuilder', classMeta);
setMetadataFor(TupleTypeBuilder, 'TupleTypeBuilder', classMeta);
setMetadataFor(AnyValue, 'AnyValue', classMeta);
setMetadataFor(PrimitiveValueAbstract, 'PrimitiveValueAbstract', classMeta);
setMetadataFor(StructuredValue, 'StructuredValue', classMeta);
setMetadataFor(TupleValue, 'TupleValue', classMeta);
setMetadataFor(TypeNamespaceAbstract, 'TypeNamespaceAbstract', classMeta, VOID, [TypeNamespace]);
setMetadataFor(SimpleTypeModelStdLib_0, 'SimpleTypeModelStdLib', objectMeta);
setMetadataFor(TypeModelSimpleAbstract, 'TypeModelSimpleAbstract', classMeta, VOID, [TypeModel]);
setMetadataFor(TypeModelSimple, 'TypeModelSimple', classMeta);
setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(TypeInstanceAbstract, 'TypeInstanceAbstract', classMeta, VOID, [TypeInstance]);
setMetadataFor(TypeInstanceSimple, 'TypeInstanceSimple', classMeta);
setMetadataFor(TupleTypeInstance, 'TupleTypeInstance', classMeta);
setMetadataFor(UnnamedSuperTypeTypeInstance, 'UnnamedSuperTypeTypeInstance', classMeta);
setMetadataFor(TypeNamespaceSimple, 'TypeNamespaceSimple', classMeta);
setMetadataFor(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(Companion, 'Companion', objectMeta);
protoOf(TypeDefinitionSimpleAbstract).instance = instance;
protoOf(TypeDefinitionSimpleAbstract).signature = signature;
setMetadataFor(TypeDefinitionSimpleAbstract, 'TypeDefinitionSimpleAbstract', classMeta, VOID, [TypeDefinition]);
protoOf(SpecialTypeSimple).signature = signature;
protoOf(SpecialTypeSimple).instance = instance;
setMetadataFor(SpecialTypeSimple, 'SpecialTypeSimple', classMeta);
protoOf(PrimitiveTypeSimple).signature = signature;
protoOf(PrimitiveTypeSimple).instance = instance;
setMetadataFor(PrimitiveTypeSimple, 'PrimitiveTypeSimple', classMeta, VOID, [TypeDefinitionSimpleAbstract, PrimitiveType]);
protoOf(EnumTypeSimple).signature = signature;
protoOf(EnumTypeSimple).instance = instance;
setMetadataFor(EnumTypeSimple, 'EnumTypeSimple', classMeta, VOID, [TypeDefinitionSimpleAbstract, EnumType]);
setMetadataFor(Companion_0, 'Companion', objectMeta);
setMetadataFor(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', classMeta);
protoOf(UnnamedSuperTypeTypeSimple).instance = instance;
protoOf(UnnamedSuperTypeTypeSimple).signature = signature;
setMetadataFor(UnnamedSuperTypeTypeSimple, 'UnnamedSuperTypeTypeSimple', classMeta, VOID, [TypeDefinitionSimpleAbstract, UnnamedSuperTypeType]);
protoOf(StructuredTypeSimpleAbstract).appendProperty = appendProperty;
protoOf(StructuredTypeSimpleAbstract).instance = instance;
protoOf(StructuredTypeSimpleAbstract).signature = signature;
setMetadataFor(StructuredTypeSimpleAbstract, 'StructuredTypeSimpleAbstract', classMeta, VOID, [TypeDefinitionSimpleAbstract, StructuredType]);
setMetadataFor(Companion_1, 'Companion', objectMeta);
protoOf(TupleTypeSimple).instance = instance;
protoOf(TupleTypeSimple).signature = signature;
protoOf(TupleTypeSimple).appendProperty = appendProperty;
setMetadataFor(TupleTypeSimple, 'TupleTypeSimple', classMeta, VOID, [StructuredTypeSimpleAbstract, TupleType]);
setMetadataFor(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', classMeta);
protoOf(DataTypeSimple).signature = signature;
protoOf(DataTypeSimple).appendProperty = appendProperty;
protoOf(DataTypeSimple).instance = instance;
setMetadataFor(DataTypeSimple, 'DataTypeSimple', classMeta, VOID, [StructuredTypeSimpleAbstract, DataType]);
protoOf(CollectionTypeSimple).signature = signature;
protoOf(CollectionTypeSimple).appendProperty = appendProperty;
protoOf(CollectionTypeSimple).instance = instance;
setMetadataFor(CollectionTypeSimple, 'CollectionTypeSimple', classMeta, VOID, [StructuredTypeSimpleAbstract, CollectionType]);
setMetadataFor(PropertyDeclarationSimple, 'PropertyDeclarationSimple', classMeta, VOID, [PropertyDeclaration]);
//endregion
//region block: exports
PropertyCharacteristic.values = values;
PropertyCharacteristic.valueOf = valueOf;
var SimpleTypeModelStdLib = {getInstance: SimpleTypeModelStdLib_getInstance};
export {
  PropertyCharacteristic,
  typeModel,
  TypeModelBuilder,
  TypeNamespaceBuilder,
  TypeUsageReferenceBuilder,
  TypeArgumentBuilder,
  SubtypeListBuilder,
  AnyValue,
  PrimitiveValueAbstract,
  StructuredValue,
  TupleValue,
  SimpleTypeModelStdLib,
  TypeModelSimple,
  TypeModelSimpleAbstract,
  TypeInstanceAbstract,
  TypeInstanceSimple,
  TupleTypeInstance,
  UnnamedSuperTypeTypeInstance,
  TypeNamespaceSimple,
  TypeNamespaceAbstract,
  TypeDefinitionSimpleAbstract,
  SpecialTypeSimple,
  PrimitiveTypeSimple,
  EnumTypeSimple,
  UnnamedSuperTypeTypeSimple,
  StructuredTypeSimpleAbstract,
  TupleTypeSimple,
  DataTypeSimple,
  CollectionTypeSimple,
  PropertyDeclarationSimple,
};
export {
  PropertyCharacteristic_COMPOSITE_getInstance as a,
  PropertyCharacteristic_CONSTRUCTOR_getInstance as b,
  PropertyCharacteristic_IDENTITY_getInstance as c,
  PropertyCharacteristic_MEMBER_getInstance as d,
  PropertyCharacteristic_REFERENCE_getInstance as e,
  SimpleTypeModelStdLib_getInstance as f,
  Companion_getInstance_1 as g,
  CollectionType as h,
  DataType as i,
  EnumType as j,
  PrimitiveType as k,
  PropertyDeclaration as l,
  StructuredType as m,
  TupleType as n,
  TypeModel as o,
  TypeNamespace as p,
  UnnamedSuperTypeType as q,
  typeModel as r,
  CollectionTypeSimple as s,
  DataTypeSimple as t,
  EnumTypeSimple as u,
  PrimitiveTypeSimple as v,
  PropertyDeclarationSimple as w,
  SimpleTypeModelStdLib_0 as x,
  SpecialTypeSimple as y,
  StructuredTypeSimpleAbstract as z,
  TupleTypeInstance as a1,
  TupleTypeSimple as b1,
  TypeDefinitionSimpleAbstract as c1,
  TypeInstanceAbstract as d1,
  TypeInstanceSimple as e1,
  TypeModelSimpleAbstract as f1,
  TypeModelSimple as g1,
  TypeNamespaceAbstract as h1,
  TypeNamespaceSimple as i1,
  UnnamedSuperTypeTypeInstance as j1,
  UnnamedSuperTypeTypeSimple as k1,
};
//endregion

//# sourceMappingURL=net.akehurst.language-type-model.mjs.map
